export const TermsOfUse = () => {
  return (
    <div className="mt-12">
      <h2 className="text-3xl font-extrabold text-center text-transform: uppercase text-gray-900 mb-20">
        Conditions générales d&apos;utilisation
      </h2>
      <h3 className="text-xl font-extrabold text-center uppercase text-gray-900 mb-20">
        En vigueur au 05/04/2023
      </h3>
      <h3 className="text-1xl font-extrabold 	text-transform: uppercase text-gray-900 mb-2 mt-6">
        Introduction
      </h3>
      <p className="text-justify mb-8">
        Les présentes conditions générales d&apos;utilisation (dites « CGU »)
        ont pour objet l&apos;encadrement juridique des modalités de mise à
        disposition du site et des services par Gaiamundi et de définir les
        conditions d&apos;accès et d&apos;utilisation des services par «
        l&apos;Utilisateur ». Les présentes CGU sont accessibles sur le site à
        la rubrique «CGU». Toute inscription ou utilisation du site implique
        l&apos;acceptation sans aucune réserve ni restriction des présentes CGU
        par l&apos;utilisateur. Lors de l&apos;inscription sur le site via le
        Formulaire d&apos;inscription, chaque utilisateur accepte expressément
        les présentes CGU en cochant la case précédant le texte suivant : « Je
        reconnais avoir lu et compris les CGU et je les accepte ». En cas de
        non-acceptation des CGU stipulées dans le présent contrat,
        l&apos;Utilisateur se doit de renoncer à l&apos;accès des services
        proposés par le site. https://gaiamundi.org se réserve le droit de
        modifier unilatéralement et à tout moment le contenu des présentes CGU.
      </p>
      <h3 className="text-1xl font-extrabold 	text-transform: uppercase text-gray-900 mt-6 mb-2">
        Article 1 : Mentions légales
      </h3>
      <p className="text-justify mb-8 ">
        L&apos;édition du site https://gaiamundi.org est assurée par la Société
        _______________ Gaiamundi au capital de _______________ euros,
        immatriculée au RCS de _______________ sous le numéro _______________,
        dont le siège social est situé au _______________ Numéro de téléphone
        _______________ Adresse e-mail : contact@gaiamundi.org. Le Directeur de
        la publication est : _______________ L&apos;hébergeur du site
        https://gaiamundi.org est la société _______________, dont le siège
        social est situé au _______________, avec le numéro de téléphone :
        _______________.
      </p>
      <h3 className="text-1xl font-extrabold 	text-transform: uppercase text-gray-900  mb-2 mt-6">
        ARTICLE 2 : Accès au site
      </h3>
      <p className="text-justify mb-8">
        Le site https://gaiamundi.org permet à l&apos;Utilisateur un accès
        gratuit aux services suivants : Le site internet propose les services
        suivants : _______________ Le site est accessible gratuitement en tout
        lieu à tout Utilisateur ayant un accès à Internet. Tous les frais
        supportés par l&apos;Utilisateur pour accéder au service (matériel
        informatique, logiciels, connexion Internet, etc.) sont à sa charge.
        L&apos;Utilisateur non membre n&apos;a pas accès aux services réservés.
        Pour cela, il doit s&apos;inscrire en remplissant le formulaire. En
        acceptant de s&apos;inscrire aux services réservés, l&apos;Utilisateur
        membre s&apos;engage à fournir des informations sincères et exactes
        concernant son état civil et ses coordonnées, notamment son adresse
        email. Pour accéder aux services, l&apos;Utilisateur doit ensuite
        s&apos;identifier à l&apos;aide de son identifiant et de son mot de
        passe qui lui seront communiqués après son inscription. Tout Utilisateur
        membre régulièrement inscrit pourra également solliciter sa
        désinscription en se rendant à la page dédiée sur son espace personnel.
        Celle-ci sera effective dans un délai raisonnable. Tout événement dû à
        un cas de force majeure ayant pour conséquence un dysfonctionnement du
        site ou serveur et sous réserve de toute interruption ou modification en
        cas de maintenance, n&apos;engage pas la responsabilité de
        https://gaiamundi.org. Dans ces cas, l&apos;Utilisateur accepte ainsi ne
        pas tenir rigueur à l&apos;éditeur de toute interruption ou suspension
        de service, même sans préavis. L&apos;Utilisateur a la possibilité de
        contacter le site par messagerie électronique à l&apos;adresse email de
        l&apos;éditeur communiqué à l’ARTICLE 1.
      </p>
      <h3 className="text-1xl font-extrabold 	text-transform: uppercase text-gray-900 mb-2 mt-6">
        ARTICLE 3 : Collecte des données
      </h3>
      <p className="text-justify ">
        Le site est exempté de déclaration à la Commission Nationale
        Informatique et Libertés (CNIL) dans la mesure où il ne collecte aucune
        donnée concernant les Utilisateurs.
      </p>
      <h3 className="text-1xl font-extrabold 	text-transform: uppercase text-gray-900 mb-2 mt-6">
        ARTICLE 4 : Propriété intellectuelle
      </h3>
      <p className="text-justify mb-8">
        Les marques, logos, signes ainsi que tous les contenus du site (textes,
        images, son…) font l&apos;objet d&apos;une protection par le Code de la
        propriété intellectuelle et plus particulièrement par le droit
        d&apos;auteur. La marque Gaiamundi est une marque déposée par
        _______________.Toute représentation et/ou reproduction et/ou
        exploitation partielle ou totale de cette marque, de quelque nature que
        ce soit, est totalement prohibée. L&apos;Utilisateur doit solliciter
        l&apos;autorisation préalable du site pour toute reproduction,
        publication, copie des différents contenus. Il s&apos;engage à une
        utilisation des contenus du site dans un cadre strictement privé, toute
        utilisation à des fins commerciales et publicitaires est strictement
        interdite. Toute représentation totale ou partielle de ce site par
        quelque procédé que ce soit, sans l&apos;autorisation expresse de
        l&apos;exploitant du site Internet constituerait une contrefaçon
        sanctionnée par l’article L 335-2 et suivants du Code de la propriété
        intellectuelle. Il est rappelé conformément à l&apos;article L122-5 du
        Code de propriété intellectuelle que l&apos;Utilisateur qui reproduit,
        copie ou publie le contenu protégé doit citer l&apos;auteur et sa
        source.
      </p>
      <h3 className="text-1xl font-extrabold 	text-transform: uppercase text-gray-900 mb-2 mt-6">
        ARTICLE 5 : Responsabilité
      </h3>
      <p className="text-justify mb-8">
        Les sources des informations diffusées sur le site https://gaiamundi.org
        sont réputées fiables mais le site ne garantit pas qu&apos;il soit
        exempt de défauts, d&apos;erreurs ou d&apos;omissions. Les informations
        communiquées sont présentées à titre indicatif et général sans valeur
        contractuelle. Malgré des mises à jour régulières, le site
        https://gaiamundi.org ne peut être tenu responsable de la modification
        des dispositions administratives et juridiques survenant après la
        publication. De même, le site ne peut être tenue responsable de
        l&apos;utilisation et de l&apos;interprétation de l&apos;information
        contenue dans ce site. L&apos;Utilisateur s&apos;assure de garder son
        mot de passe secret. Toute divulgation du mot de passe, quelle que soit
        sa forme, est interdite. Il assume les risques liés à l&apos;utilisation
        de son identifiant et mot de passe. Le site décline toute
        responsabilité. Le site https://gaiamundi.org ne peut être tenu pour
        responsable d&apos;éventuels virus qui pourraient infecter
        l&apos;ordinateur ou tout matériel informatique de l&apos;Internaute,
        suite à une utilisation, à l&apos;accès, ou au téléchargement provenant
        de ce site. La responsabilité du site ne peut être engagée en cas de
        force majeure ou du fait imprévisible et insurmontable d&apos;un tiers.
      </p>
      <h3 className="text-1xl font-extrabold 	text-transform: uppercase text-gray-900 mb-2 mt-6">
        ARTICLE 6 : Liens hypertextes
      </h3>
      <p className="text-justify mb-8">
        Des liens hypertextes peuvent être présents sur le site.
        L&apos;Utilisateur est informé qu&apos;en cliquant sur ces liens, il
        sortira du site https://gaiamundi.org. Ce dernier n&apos;a pas de
        contrôle sur les pages web sur lesquelles aboutissent ces liens et ne
        saurait, en aucun cas, être responsable de leur contenu.
      </p>
      <h3 className="text-1xl font-extrabold 	text-transform: uppercase text-gray-900 mb-2 mt-6">
        ARTICLE 7 : Cookies
      </h3>
      <p className="text-justify ">
        L&apos;Utilisateur est informé que lors de ses visites sur le site, un
        cookie peut s&apos;installer automatiquement sur son logiciel de
        navigation. Les cookies sont de petits fichiers stockés temporairement
        sur le disque dur de l&apos;ordinateur de l&apos;Utilisateur par votre
        navigateur et qui sont nécessaires à l&apos;utilisation du site
        https://gaiamundi.org. Les cookies ne contiennent pas d&apos;information
        personnelle et ne peuvent pas être utilisés pour identifier
        quelqu&apos;un. Un cookie contient un identifiant unique, généré
        aléatoirement et donc anonyme. Certains cookies expirent à la fin de la
        visite de l&apos;Utilisateur, d&apos;autres restent. L’information
        contenue dans les cookies est utilisée pour améliorer le site
        https://gaiamundi.org. En naviguant sur le site, L&apos;Utilisateur les
        accepte. L&apos;Utilisateur pourra désactiver ces cookies par
        l&apos;intermédiaire des paramètres figurant au sein de son logiciel de
        navigation.
      </p>
      <h3 className="text-1xl font-extrabold 	text-transform: uppercase text-gray-900 mb-2 mt-6">
        ARTICLE 8 : Publication par l’Utilisateur
      </h3>
      <p className="text-justify mb-8">
        Le site permet aux membres de publier les contenus suivants : PageCarto.
        Dans ses publications, le membre s&apos;engage à respecter les règles de
        la Netiquette (règles de bonne conduite de l&apos;internet) et les
        règles de droit en vigueur. Le site peut exercer une modération sur les
        publications et se réserve le droit de refuser leur mise en ligne, sans
        avoir à s&apos;en justifier auprès du membre. Le membre reste titulaire
        de l&apos;intégralité de ses droits de propriété intellectuelle. Mais en
        publiant une publication sur le site, il cède à la société éditrice le
        droit non exclusif et gratuit de représenter, reproduire, adapter,
        modifier, diffuser et distribuer sa publication, directement ou par un
        tiers autorisé, dans le monde entier, sur tout support (numérique ou
        physique), pour la durée de la propriété intellectuelle. Le Membre cède
        notamment le droit d&apos;utiliser sa publication sur internet et sur
        les réseaux de téléphonie mobile. La société éditrice s&apos;engage à
        faire figurer le nom du membre à proximité de chaque utilisation de sa
        publication. Tout contenu mis en ligne par l&apos;Utilisateur est de sa
        seule responsabilité. L&apos;Utilisateur s&apos;engage à ne pas mettre
        en ligne de contenus pouvant porter atteinte aux intérêts de tierces
        personnes. Tout recours en justice engagé par un tiers lésé contre le
        site sera pris en charge par l&apos;Utilisateur. Le contenu de
        l&apos;Utilisateur peut être à tout moment et pour n&apos;importe quelle
        raison supprimé ou modifié par le site, sans préavis.
      </p>
      <h3 className="text-1xl font-extrabold 	text-transform: uppercase text-gray-900 mb-2 mt-6">
        ARTICLE 9 : Droit applicable et juridiction compétente
      </h3>
      <p className="text-justify mb-8">
        La législation française s&apos;applique au présent contrat. En cas
        d&apos;absence de résolution amiable d&apos;un litige né entre les
        parties, les tribunaux français seront seuls compétents pour en
        connaître. Pour toute question relative à l&apos;application des
        présentes CGU, vous pouvez joindre l&apos;éditeur aux coordonnées
        inscrites à l’ARTICLE 1.
      </p>
    </div>
  );
};
